import { render, staticRenderFns } from "./NavigationMenuLinks.vue?vue&type=template&id=3f653f04&scoped=true"
import script from "./NavigationMenuLinks.vue?vue&type=script&lang=js"
export * from "./NavigationMenuLinks.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuLinks.vue?vue&type=style&index=0&id=3f653f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f653f04",
  null
  
)

export default component.exports